export const TARGET_CLS = 'ant-wave-target';